<h4>{{ column.label }}</h4>
<fc-tool-tip [primary]="column.additionalInfo" [secondary]="column.description" [marginLeft]="0"></fc-tool-tip>
<div class="fc-primary" [innerHtml]="column.primaryMessage | markedInline" [title]="getPrimaryToolTip(column)" [ngClass]="getToolTipClass(column)"></div>
<div class="fc-secondary" [innerHtml]="column.secondaryMessage | markedInline"></div>